export default "__VITE_ASSET__BQ1mL76I__"